"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Common = /*#__PURE__*/function () {
  function Common(client) {
    (0, _classCallCheck2["default"])(this, Common);
    this.client = client;
    this.resourceUrl = '/admin';
  }

  (0, _createClass2["default"])(Common, [{
    key: "getSiteWideSearcResulth",
    value: function getSiteWideSearcResulth(search) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/wide-search?query=").concat(search), args);
    }
  }, {
    key: "addIndividualUser",
    value: function addIndividualUser(type, id, data) {
      var _this$client;

      for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      return (_this$client = this.client).post.apply(_this$client, ["/".concat(type, "/").concat(id, "/individual-user"), data].concat(args));
    }
  }, {
    key: "getSOWData",
    value: function getSOWData(type, id) {
      var _this$client2;

      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return (_this$client2 = this.client).get.apply(_this$client2, ["/b2b-sow/type/".concat(type, "/").concat(id)].concat(args));
    }
  }, {
    key: "checkDuplicateGroupName",
    value: function checkDuplicateGroupName(data) {
      var _this$client3;

      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return (_this$client3 = this.client).post.apply(_this$client3, ['/b2b-sow/check-duplicate-sow-group', data].concat(args));
    }
  }, {
    key: "getUsersInSOW",
    value: function getUsersInSOW(sowId, reqData) {
      var _this$client4;

      for (var _len5 = arguments.length, args = new Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
        args[_key5 - 2] = arguments[_key5];
      }

      return (_this$client4 = this.client).post.apply(_this$client4, ["/b2b-sow/".concat(sowId, "/users"), reqData].concat(args));
    }
  }, {
    key: "getSOWGroupUsers",
    value: function getSOWGroupUsers(sowGroupId, reqData) {
      var _this$client5;

      for (var _len6 = arguments.length, args = new Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
        args[_key6 - 2] = arguments[_key6];
      }

      return (_this$client5 = this.client).post.apply(_this$client5, ["/b2b-sow/team/".concat(sowGroupId, "/members"), reqData].concat(args));
    }
  }, {
    key: "getUsersBySOWAndGroupId",
    value: function getUsersBySOWAndGroupId(sowId, sowGroupId, reqData) {
      var _this$client6;

      for (var _len7 = arguments.length, args = new Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
        args[_key7 - 3] = arguments[_key7];
      }

      return (_this$client6 = this.client).post.apply(_this$client6, ["/b2b-sow/".concat(sowId, "/team/").concat(sowGroupId, "/excluded-members"), reqData].concat(args));
    }
  }, {
    key: "getCompanyEcoComparisonReportForCommonUsers",
    value: function getCompanyEcoComparisonReportForCommonUsers(params, type) {
      for (var _len8 = arguments.length, args = new Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
        args[_key8 - 2] = arguments[_key8];
      }

      return this.client.get("/survey/".concat(type, "-comparison-report-with-common-user").concat(params), args);
    }
  }, {
    key: "bulkAssignCoachToUser",
    value: function bulkAssignCoachToUser(data) {
      var _this$client7;

      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return (_this$client7 = this.client).post.apply(_this$client7, ['/admin/bulk-assign-coaches', data].concat(args));
    }
  }, {
    key: "bulkAssignSOWToUser",
    value: function bulkAssignSOWToUser(data) {
      var _this$client8;

      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return (_this$client8 = this.client).post.apply(_this$client8, ['/admin/bulk-assign-sow', data].concat(args));
    }
  }, {
    key: "clientCoachBulkPairing",
    value: function clientCoachBulkPairing(data) {
      var _this$client9;

      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return (_this$client9 = this.client).post.apply(_this$client9, ['/user/client-coach-bulk-pairing', data].concat(args));
    }
  }, {
    key: "getSearchMedia",
    value: function getSearchMedia(search, type, userId) {
      var str = "/medias/search/?search=".concat(encodeURIComponent(search), "&type=").concat(type);

      if (type === 'user') {
        str += "&userId=".concat(userId);
      }

      for (var _len12 = arguments.length, args = new Array(_len12 > 3 ? _len12 - 3 : 0), _key12 = 3; _key12 < _len12; _key12++) {
        args[_key12 - 3] = arguments[_key12];
      }

      return this.client.get(str, args);
    }
  }, {
    key: "getKeySkillSearchPdf",
    value: function getKeySkillSearchPdf() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return this.client.get('/medias/key-skills', args);
    }
  }, {
    key: "getClientSurveyLogs",
    value: function getClientSurveyLogs(clientId, sowId, planId) {
      var _this$client10;

      var query = planId && planId !== 'create' ? "?sessionId=".concat(planId) : '';

      for (var _len14 = arguments.length, args = new Array(_len14 > 3 ? _len14 - 3 : 0), _key14 = 3; _key14 < _len14; _key14++) {
        args[_key14 - 3] = arguments[_key14];
      }

      return (_this$client10 = this.client).get.apply(_this$client10, ["/survey/client/".concat(clientId, "/sow/").concat(sowId, "/log").concat(query)].concat(args));
    }
  }]);
  return Common;
}();

exports["default"] = Common;